import { saveAnswer } from '../../../service';

const pendingSaves = new Map();

// Autosave and Continue write the same submission. A second request must wait
// for the first to settle so it cannot conflict with the server's write fence
// or let an older autosave overwrite the answer approved for marking.
export const saveReviewedAnswer = (submissionId, ...args) => {
  const key = String(submissionId);
  const previous = pendingSaves.get(key) || Promise.resolve();
  const next = previous.catch(() => {}).then(() => saveAnswer(submissionId, ...args));
  pendingSaves.set(key, next);
  const clear = () => {
    if (pendingSaves.get(key) === next) pendingSaves.delete(key);
  };
  next.then(clear, clear);
  return next;
};
